// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageHeader-moduleblocked__H79KF";
var _2 = "ChatroomMessageHeader-modulechatroomMessageHeader__Swu9q";
var _3 = "ChatroomMessageHeader-moduleheaderInfo__mFk_a";
export { _1 as "blocked", _2 as "chatroomMessageHeader", _3 as "headerInfo" }
